export default {
  name: "ScrollableList",
  data() {
    return {
      scrollDistance: 0
    };
  },
  mounted() {
    setTimeout(() => {
      this.startScroll();
    }, 2000);
  },
  methods: {
    startScroll() {
      const scrollableList = this.$refs.scrollableList;
      const containerHeight = scrollableList.offsetHeight;
      const contentHeight = scrollableList.scrollHeight;
      console.log(contentHeight, containerHeight, "内容不足以滚动");
      const speed = this.speed || 50; // 默认滚动速度为 50

      if (contentHeight <= containerHeight) {
        console.log('内容不足以滚动');
        return; // 内容不足以滚动
      }

      // this.scrollDistance = 0;

      const scroll = () => {
        this.scrollDistance += 1; // 每次滚动的距离
        if (this.scrollDistance >= contentHeight) {
          this.scrollDistance = 0;
        }
        scrollableList.scrollTop = this.scrollDistance;
        this.scrollTimeout = setTimeout(scroll, speed);
      };
      this.scrollTimeout = setTimeout(scroll, speed);
    },
    stopScroll() {
      clearTimeout(this.scrollTimeout);
    },
    handleScroll() {
      const scrollableList = this.$refs.scrollableList;
      this.scrollDistance = scrollableList.scrollTop;
    }
  },
  beforeDestroy() {
    clearTimeout(this.scrollTimeout);
  },
  props: {
    speed: {
      type: Number,
      default: 50 // 默认滚动速度为 50
    }
  }
};